import { createI18n } from 'vue-i18n'
import en from './en.json'
import uk from './uk.json'

const selectedLocale = localStorage.getItem('selectedLocale')

const i18n = createI18n({
  legacy: true,
  globalInjection: true,
  locale: selectedLocale || 'uk',
  fallbackLocale: 'en',
  messages: { uk, en },
})

export default i18n
